
import React from 'react';

interface EstimateBankingInfoProps {
  company: {
    "Use Bank Info"?: boolean;
    "Bank Name"?: string;
    "Branch Name"?: string;
    "Branch Code"?: string;
    "Account Holder"?: string;
    "Account Number"?: string;
  };
  estimateNumber?: string;
}

const EstimateBankingInfo: React.FC<EstimateBankingInfoProps> = ({ company, estimateNumber }) => {
  // Only show banking info if the toggle is enabled and we have at least some banking data
  if (!company?.["Use Bank Info"]) {
    return null;
  }

  const bankingData = [
    { label: 'Bank Name', value: company?.["Bank Name"] },
    { label: 'Branch Name', value: company?.["Branch Name"] },
    { label: 'Branch Code', value: company?.["Branch Code"] },
    { label: 'Account Holder', value: company?.["Account Holder"] },
    { label: 'Account Number', value: company?.["Account Number"] }
  ];

  // Filter out empty values
  const validBankingData = bankingData.filter(item => item.value);

  if (validBankingData.length === 0) {
    return null;
  }

  return (
    <div 
      className="mt-8 pt-4" 
      style={{ 
        pageBreakInside: 'avoid',
        breakInside: 'avoid'
      }}
    >
      <div style={{ fontSize: '14px', lineHeight: '1.4' }}>
        {validBankingData.map((item, index) => (
          <div key={index} className="mb-1">
            <span style={{ fontWeight: 'bold' }}>{item.label}:</span> {item.value}
          </div>
        ))}
        {estimateNumber && (
          <div className="mb-1">
            <span style={{ fontWeight: 'bold' }}>Payment Ref:</span>{' '}
            <span style={{ fontWeight: 'bold', color: '#036CFF' }}>
              {estimateNumber}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EstimateBankingInfo;
